/**
 * Interceptors support following methods:
 * request, response, requestError, responseError
 */

(function () {
	angular
		.module('trackeye')
		.factory('LanguageInjector', LanguageInjector);

	LanguageInjector.$inject = ['$injector'];

	function LanguageInjector($injector) {
		var exports = {};

		exports.request = function (config) {
			var LanguageService = $injector.get('LanguageService');
			config.headers['Accept-Language'] = LanguageService.getCurrentLanguage()

			return config;
		}

		return exports;
	}
})();